module.exports = __webpack_public_path__ + "img/ld2.dd5a7c2d.jpg";